export default __webpack_public_path__ + "static/bg-dota-banner-57e9b9f8ffb8a95d1e0a4658933568da.png";